import { makeActionCreator } from "../../utils";

export const OFFICIAL_NAME_CHANGED = "ORDERS.OFFICIAL_NAME.OFFICIAL_NAME_CHANGED";

export const officialNameChanged = makeActionCreator(OFFICIAL_NAME_CHANGED, "payload");
